<script setup>
    import { defineExpose, defineEmits, ref, inject } from 'vue';
    import { useConsultationWebStore } from '@/stores/consultation/consultationWebStore';
    import BaseInput from './../../components/BaseInputComponent.vue';
    import { WebdtlResponce } from '@/models/consultationWebModel';
    import { getCurrentInstance } from 'vue';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import Utils from '@/commonProject/helpers/utils.js';
    import i18n from '@/common/i18n';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');
    // web相談ストア
    const consultationWebStore = useConsultationWebStore();
    // Web相談詳細情報レスポンス
    const webdtlResponce = ref({});
    // モーダルフラグ
    const registrationCompleteDispFlg = ref('');
    const registrationApplyArmDispFlg = ref('');
    const registrationConfirmDispFlg = ref('');

    const languageStore = useLanguageStore();

    const app = getCurrentInstance();

    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;
 
    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();
    /**
     * 初期処理 親画面から利用可能関数
     * @param web_cng_no Web相談番号
     */
    async function setInfo(WebCngPk) {
        // ストア側詳細情報の初期化
        consultationWebStore.webdtlResponce = {};
        consultationWebStore.armRegistrationIssue = [];
        // モーダル側で保持しているデータの初期化
        webdtlResponce.value = new WebdtlResponce();
        // モーダルフラグ設定
        registrationApplyArmDispFlg.value = 'block';
        registrationConfirmDispFlg.value = '';
        registrationCompleteDispFlg.value = '';

        webdtlResponce.value.WebCngPk = WebCngPk;

        // お知らせ詳細からの遷移の場合
        if (!Utils.isNullEmpty(consultationWebStore.noticeHistPk)) {
            webdtlResponce.value.NoticeHistPk = consultationWebStore.noticeHistPk;
            consultationWebStore.noticeHistPk = '';
        }

        // Web相談番号が存在する場合
        if (!Utils.isNullEmpty(webdtlResponce.value.WebCngPk)) {
            // Web相談の詳細情報取得
            await getRegistrationInformation(webdtlResponce.value.WebCngPk);
        }

        // セレクトボックスの中身取得
        await getArmIssue();

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalWebConsultationEntryType1 .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }
    defineExpose({
        setInfo,
    });

    /**
     * Web相談詳細情報取得処理
     * @param WebCngPk Web相談PK
     */
    async function getRegistrationInformation(WebCngPk) {
        const queryParam = {
            Lang: languageStore.getLanguageValue,
            WebCngPk: WebCngPk,
        };
        const response = await consultationWebStore.getRegistrationInformation(API_URL, queryParam);
        if (response.success) {
            webdtlResponce.value = Object.assign(webdtlResponce.value, consultationWebStore.webdtlResponce);
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * セレクトボックス情報取得処理
     * @param
     */
    async function getArmIssue() {
        const requestBody = {
            Lang: languageStore.getLanguageValue,
        };
        const response = await consultationWebStore.getArmIssue(API_URL, requestBody);
        if (response.success) {
            if (Utils.isNullEmpty(webdtlResponce.value.WebCngArmIsuPk)) {
                webdtlResponce.value.WebCngArmIsuPk = consultationWebStore.armRegistrationIssue[0].pk;
            }
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * Web相談登録入力(ARM型)登録処理
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function registerConsultationWeb(WebCngOpeMode) {
        let requestBody = {
            WebCngOpeMode: WebCngOpeMode,
            //WebCngPk: webdtlResponce.value.WebCngPk,
            //NoticeHistPk: webdtlResponce.value.NoticeHistPk,
            WebCngArmSubj: webdtlResponce.value.WebCngArmSubj,
            WebCngArmIsuPk: webdtlResponce.value.WebCngArmIsuPk,
            WebCngArmCont: webdtlResponce.value.WebCngArmCont,
        };

        // Web相談の新規登録以外で、既存の相談の詳細から再編集を行う場合や、相談を終了等を行う場合。
        if (!Utils.isNullEmpty(webdtlResponce.value.WebCngPk)) {
            requestBody['WebCngPk'] = webdtlResponce.value.WebCngPk;
        }

        // ホーム画面のお知らせ詳細の現況把握お知らせからの遷移の場合。
        if (!Utils.isNullEmpty(webdtlResponce.value.NoticeHistPk)) {
            requestBody['NoticeHistPk'] = webdtlResponce.value.NoticeHistPk;
        }

        const response = await consultationWebStore.registerConsultationWeb(API_URL, requestBody);
        if (response.success) {
            return true;
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return false;
        }
    }

    /**
     * Web相談登録入力(ARM型)「削除」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function deleted(WebCngOpeMode) {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        await registerConsultationWeb(WebCngOpeMode);
        cancelUpdate();
    }

    /**
     * Web相談登録入力(ARM型)「一時保存」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function temporaryStorage(WebCngOpeMode) {
        // バリデーションチェック
        if (isValidationError()) {
            return;
        }
        
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();
        
        await registerConsultationWeb(WebCngOpeMode);
        cancelUpdate();
    }

    /**
     * Web相談登録入力(ARM型)「登録」
     */
    function nextModal() {
        // バリデーションチェック
        if (isValidationError()) {
            return;
        }

        registrationApplyArmDispFlg.value = '';
        registrationConfirmDispFlg.value = 'block';
    }

    /**
     * バリデーションチェック
     */
    function isValidationError() {
        // エラーメッセージを初期化する。
        let message = '';

        //件名入力
        if (Utils.isNullEmpty(webdtlResponce.value.WebCngArmSubj)) {
            //件名が入ってない場合
            message += i18n.global.t('consultationWebRegistrationApplyArm.message.message1') + '\n';
        } else {
            if (Utils.checkLengthOfString(webdtlResponce.value.WebCngArmSubj)) {
                //件名が128字より多い場合
                message += i18n.global.t('consultationWebRegistrationApplyArm.message.message2') + '\n';
            }
        }

        //相談内容入力
        if (Utils.isNullEmpty(webdtlResponce.value.WebCngArmIsuPk)) {
            //相談内容が選択されてない場合
            message += i18n.global.t('consultationWebRegistrationApplyArm.message.message3') + '\n';
        }

        //本文内容入力
        if (Utils.isNullEmpty(webdtlResponce.value.WebCngArmCont)) {
            //本文が入力されてない場合
            message += i18n.global.t('consultationWebRegistrationApplyArm.message.message4') + '\n';
        } else {
            if (Utils.checkLengthOfLongString(webdtlResponce.value.WebCngArmCont)) {
                //本文が2000より多い場合
                message += i18n.global.t('consultationWebRegistrationApplyArm.message.message5') + '\n';
            }
        }

        // エラーメッセージが存在する場合は、以降の処理に進ませないので、バリデーションチェック判定を返却する。
        if (!Utils.isNullEmpty(message)) {
            // エラーメッセージが存在する場合は、画面に表示する。
            messageDialog('error', message);
            return true;
        }
        return false;
    }

    /**
     * Web相談登録確認モーダル「いいえ」
     */
    function backModal() {
        registrationApplyArmDispFlg.value = 'block';
        registrationConfirmDispFlg.value = '';
    }

    /**
     * Web相談登録確認モーダル「はい」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function confirmationOk(WebCngOpeMode) {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        const results = await registerConsultationWeb(WebCngOpeMode);
        if (results) {
            registrationConfirmDispFlg.value = '';
            registrationCompleteDispFlg.value = 'block';
        }
    }

    /**
     * 親画面で実装必須関数
     */
    const emit = defineEmits(['registrationApplyArmModal:cancel', 'registrationApplyArmModal:cancelUpdate', 'registrationApplyArmModal:regist']);
    function cancel() {
        // 親画面のキャンセル処理を呼び出す
        emit('registrationApplyArmModal:cancel');
    }
    function cancelUpdate() {
        // 親画面の更新キャンセル処理を呼び出す
        emit('registrationApplyArmModal:cancelUpdate');
    }
</script>

<template>
    <article id="modalWebConsultationEntryType1" class="modal" :style="{ display: registrationApplyArmDispFlg }">
        <!--Web相談登録入力(ARM型)モーダル-->
        <h3>{{ $t('consultationWebRegistrationApplyArm.parts.modalTitle1') }}</h3>
        <section class="modalContents" :class="webdtlResponce.WebCngStatus === '1' ? 'quad' : 'triple'">
            <section class="form">
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebRegistrationApplyArm.parts.dl1') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <BaseInput v-model:input="webdtlResponce.WebCngArmSubj" type="text" />
                            </li>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebRegistrationApplyArm.parts.dl2') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <div class="select">
                                    <select v-model="webdtlResponce.WebCngArmIsuPk" required>
                                        <option v-for="contents in consultationWebStore.armRegistrationIssue" :key="contents.pk" :value="contents.pk">
                                            {{ contents.name }}
                                        </option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebRegistrationApplyArm.parts.dl3') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <textarea class="textAreaTypeA" v-model="webdtlResponce.WebCngArmCont" style="height: 140px"/>
                                <span>{{ $t('consultationWebRegistrationApplyArm.parts.dl4') }}</span>
                            </li>
                        </ul>
                    </dd>
                </dl>
            </section>
        </section>
        <section class="modalFooter">
            <ul class="btnArea center short">
                <li>
                    <button type="button" class="btnNormal" @click="cancel">{{ $t('consultationWebRegistrationApplyArm.parts.modalButton1') }}</button>
                </li>
                <li v-if="webdtlResponce.WebCngStatus === '1'">
                    <button type="button" class="btnSecondary" @click="deleted('3')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebRegistrationApplyArm.parts.modalButton2') }}</button>
                </li>
                <li>
                    <button type="button" class="btnSecondary" @click="temporaryStorage('2')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebRegistrationApplyArm.parts.modalButton3') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="nextModal">{{ $t('common.parts.entry') }}</button>
                </li>
            </ul>
        </section>
    </article>
    <article id="modalWebConsultationEntryCheck" class="modal small" :style="{ display: registrationConfirmDispFlg }">
        <!--Web相談登録確認モーダル-->
        <p class="textCenter" style="margin-bottom: 20px">{{ $t('consultationWebRegistrationConfirm.parts.modalTitle1') }}</p>
        <p class="textCenter" style="font-size: 16px">{{ $t('consultationWebRegistrationConfirm.parts.modalInformation1') }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="backModal">{{ $t('consultationWebRegistrationConfirm.parts.modalButton1') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="confirmationOk('1')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebRegistrationConfirm.parts.modalButton2') }}</button>
                </li>
            </ul>
        </section>
    </article>
    <article id="modalWebConsultationEntryComplete" class="modal small" :style="{ display: registrationCompleteDispFlg }">
        <!--Web相談登録完了モーダル-->
        <p class="textCenter">{{ $t('consultationWebRegistrationComplete.parts.modalTitle1') }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="cancelUpdate()">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>

<style></style>
